export default "__VITE_ASSET__BscZk6GL__"